import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, getCountFromServer, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [bookedrooms, setbookedrooms] = useState(0);
    const [availablerooms, setavailablerooms] = useState(0);
    const [cleaningrooms, setcleaningrooms] = useState(0);
    const [allrooms, setallrooms] = useState(0);

    const [todayCount, settodayCount] = useState(0);
    const [tommCount, settommCount] = useState(0);
    const [thisMonth, setthisMonth] = useState(0);
    const [nextMonth, setnextMonth] = useState(0);

    const [todayCount1, settodayCount1] = useState(0);
    const [tommCount1, settommCount1] = useState(0);
    const [thisMonth1, setthisMonth1] = useState(0);
    const [nextMonth1, setnextMonth1] = useState(0);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    }, [userData]);


    const fetchData1 = async () => {
        try {
            if (userData) {
                const q1 = query(collection(db, 'roomdetails'));
                const snapshot1 = await getDocs(q1);
                setallrooms(snapshot1.size);

                const q2 = query(collection(db, 'roomdetails'), where('status', '==', "Booked"));
                const querySnapshot1 = await getDocs(q2);
                setbookedrooms(querySnapshot1.size);

                const q3 = query(collection(db, 'roomdetails'), where("status", '==', 'Available'));
                const snapshot2 = await getDocs(q3);
                setavailablerooms(snapshot2.size);

                const q4 = query(collection(db, 'roomdetails'), where("status", '==', 'Cleaning'));
                const snapshot3 = await getDocs(q4);
                setcleaningrooms(snapshot3.size);

                const today = new Date().toISOString().split('T')[0];
                let toommorrow = moment().add(1, 'days').format('YYYY-MM-DD');

                const q5 = query(collection(db, 'websitebookings'), where('checkindate', '==', today), where('status', '==', 'Paid'));
                const snapshot5 = await getDocs(q5);
                settodayCount(snapshot5.size);

                const q6 = query(collection(db, 'websitebookings'), where('checkindate', '==', toommorrow), where('status', '==', 'Paid'));
                const snapshot6 = await getDocs(q6);
                settommCount(snapshot6.size);

                const firstDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
                const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');

                const q7 = query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid'));
                const snapshot7 = await getDocs(q7);
                setthisMonth(snapshot7.size);

                const firstDayOfNextMonth = moment().add(1, 'months').startOf('month').format('YYYY-MM-DD');
                const lastDayOfNextMonth = moment().add(1, 'months').endOf('month').format('YYYY-MM-DD');

                const q8 = query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid'));
                const snapshot8 = await getDocs(q8);
                setnextMonth(snapshot8.size);



                const q9 = query(collection(db, 'advancebookings'), where('checkindate', '==', today), where('status', '==', 'Paid'));
                const snapshot9 = await getDocs(q9);
                settodayCount1(snapshot9.size);

                const q10 = query(collection(db, 'advancebookings'), where('checkindate', '==', toommorrow), where('status', '==', 'Paid'));
                const snapshot10 = await getDocs(q10);
                settommCount1(snapshot10.size);

                const q11 = query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid'));
                const snapshot11 = await getDocs(q11);
                setthisMonth1(snapshot11.size);

                const q12 = query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid'));
                const snapshot12 = await getDocs(q12);
                setnextMonth1(snapshot12.size);


            }
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
            console.log(error.message);

        }
    }



    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <button
                            className="btn btn-secondary"
                            style={{ marginBottom: "20px", padding: "8px 20px", fontWeight: "bold" }}
                        >
                            || Dashboard ||
                        </button>

                        {/* Row 1 */}
                        <div className="row">
                            {/* Today's Bookings */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #ff7eb3, #ff758c)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{todayCount + todayCount1}</h3>
                                        <p>Today's Bookings</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-calendar-day"></i>
                                    </div>
                                </div>
                            </div>

                            {/* Tomorrow's Bookings */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #ffaf7b, #d76d77)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{tommCount + tommCount1}</h3>
                                        <p>Tomorrow's Bookings</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-calendar-plus"></i>
                                    </div>
                                </div>
                            </div>

                            {/* This Month Bookings */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #6a11cb, #2575fc)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{thisMonth + thisMonth1}</h3>
                                        <p>This Month Bookings</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-calendar-alt"></i>
                                    </div>
                                </div>
                            </div>

                            {/* Next Month Bookings */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #43cea2, #185a9d)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{nextMonth + nextMonth1}</h3>
                                        <p>Next Month Bookings</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-calendar-check"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Row 2 */}
                        <div className="row" style={{ marginTop: "20px" }}>
                            {/* Live Bookings */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #ff416c, #ff4b2b)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{bookedrooms}</h3>
                                        <p>Live Booking Rooms</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-bed"></i>
                                    </div>
                                    <a href="live-booking-rooms" style={{ color: "white", textDecoration: "underline", fontSize: "14px" }}>
                                        More info <i className="fas fa-arrow-circle-right"></i>
                                    </a>
                                </div>
                            </div>

                            {/* Available Rooms */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #56ab2f, #a8e063)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{availablerooms}</h3>
                                        <p>Available Rooms</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-door-open"></i>
                                    </div>
                                    <a href="available-rooms" style={{ color: "white", textDecoration: "underline", fontSize: "14px" }}>
                                        More info <i className="fas fa-arrow-circle-right"></i>
                                    </a>
                                </div>
                            </div>

                            {/* Cleaning Rooms */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #f7971e, #ffd200)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{cleaningrooms}</h3>
                                        <p>Cleaning Rooms</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-broom"></i>
                                    </div>
                                    <a href="cleaning-rooms" style={{ color: "white", textDecoration: "underline", fontSize: "14px" }}>
                                        More info <i className="fas fa-arrow-circle-right"></i>
                                    </a>
                                </div>
                            </div>

                            {/* All Rooms */}
                            <div className="col-lg-3 col-6">
                                <div
                                    style={{
                                        background: "linear-gradient(135deg, #00c6ff, #0072ff)",
                                        color: "white",
                                        borderRadius: "10px",
                                        padding: "20px",
                                        position: "relative",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    <div className="inner">
                                        <h3>{allrooms}</h3>
                                        <p>All Rooms</p>
                                    </div>
                                    <div className="icon" style={{ position: "absolute", right: "15px", top: "15px", fontSize: "40px" }}>
                                        <i className="fas fa-hotel"></i>
                                    </div>
                                    <a href="all-rooms" style={{ color: "white", textDecoration: "underline", fontSize: "14px" }}>
                                        More info <i className="fas fa-arrow-circle-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>


                </section>

            </div>


        </div>
    )
}

export default Dashboard
